var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// import "./css/App.css";
//i18n engine
import { I18nextProvider } from "react-i18next";
import i18n from "../src/component/translation/i18n";
//component
import HomeLayout from "./component/HomeAndNavigation/HomeLayout";
import { Alert, CircularProgress, createTheme, Snackbar, ThemeProvider } from "@mui/material";
import { useState, useEffect } from "react";
import { isLoading, isAPIServerError, checkDrawerOpen, isAuthorized } from "./services/behaviorSubjectService";
import { isLoadingCSS } from "./css/NavigationObjectCss";
import { addOnclickEventOnShopifyAccountIcon } from "./services/apiServices/salesRepDataService";
import { createBrowserHistory } from "history";
import LoginComponent from "./component/LoginComponent/LoginComponent";
import { TOASTER_TIMEOUT } from "./component/Constant";
// Default the portal to full screen (Shopify chrome hidden) before the first render, so both the
// login page and the post-login dashboard start full screen. Runs at module load — earlier than any
// component's initial state — so the toggles (login / navbar) read the class and show the right state.
// The stylesheet that actually hides the chrome is injected on App mount (ensureShopifyChromeStyle).
if (typeof document !== "undefined") {
    document.documentElement.classList.add("st-hide-shopify-chrome");
}
export default function App() {
    var _a = useState(false), isLoader = _a[0], setIsLoader = _a[1];
    var _b = useState(false), isSnackbar = _b[0], setIsSnackbar = _b[1];
    var _c = useState(false), isDrawerOpen = _c[0], setIsDrawerOpen = _c[1];
    var _d = useState(""), parsedAuthentication = _d[0], setParsedAuthentication = _d[1];
    var overrideDefaultTheme = createTheme({
        zIndex: {
            modal: 99999,
            tooltip: 99999,
            snackbar: 99999,
            drawer: 99999,
        },
    });
    isLoading.subscribe(function (data) {
        if (data !== isLoader)
            setIsLoader(data);
    });
    isAPIServerError.subscribe(function (data) {
        if (data !== isSnackbar)
            setIsSnackbar(data);
    });
    useEffect(function () {
        isAuthorized.subscribe(function (data) {
            var authenticationDetails = sessionStorage.getItem("Authorization");
            //  Unicode-safe atob for different languages (Japanese, Chinese, etc.)
            setParsedAuthentication(authenticationDetails ? JSON.parse(decodeURIComponent(escape(atob(authenticationDetails)))) : "");
        });
    }, [isAuthorized]);
    //attach custom onclick event on customer account icon
    useEffect(function () {
        addOnclickEventOnShopifyAccountIcon(setIsDrawerOpen);
    });
    // Inject the "hide Shopify chrome" stylesheet once so the full-screen toggles (navbar / login)
    // only need to add/remove the html.st-hide-shopify-chrome class. Chrome restored on unmount.
    useEffect(function () {
        ensureShopifyChromeStyle();
        return function () { return toggleShopifyChrome(false); };
    }, []);
    useEffect(function () {
        isDrawerOpen ? injectSalesTeamCss() : removeSalesTeamCss();
        checkDrawerOpen.next(isDrawerOpen);
    }, [isDrawerOpen]);
    //Redirect to backoffice once customer login
    var history = createBrowserHistory();
    useEffect(function () {
        var url = window.location.href;
        var customerAccountPageUrl = "/account";
        if ((url === null || url === void 0 ? void 0 : url.includes(customerAccountPageUrl)) && url.substring(url.indexOf(customerAccountPageUrl)) === customerAccountPageUrl) {
            setIsDrawerOpen(true);
        }
    }, [history]);
    //Stop scrollable behaviour of storefront once backoffice opened
    useEffect(function () {
        var bodyElement = document.getElementsByTagName("body")[0];
        bodyElement.style.overflow = isDrawerOpen ? "hidden" : "auto";
        checkDrawerOpen.next(isDrawerOpen);
    }, [isDrawerOpen]);
    useEffect(function () {
        var userAgent = navigator.userAgent.toLowerCase();
        var isSafari = navigator.vendor.includes("Apple");
        if (isSafari) {
            document.documentElement.classList.add("safari-browser");
        }
        else {
            document.documentElement.classList.remove("safari-browser");
        }
    }, []);
    var injectSalesTeamCss = function () {
        document.getElementsByTagName("html")[0].style.fontSize = "14px";
    };
    var removeSalesTeamCss = function () {
        document.getElementsByTagName("html")[0].style.fontSize = "small";
    };
    // Hide/show the Shopify storefront chrome (announcement bar, header, footer) rendered
    // by the theme (Liquid) — these live outside #css-backoffice so we toggle them via a
    // <style> keyed on a class added to <html>. The app's own blue Navbar is unaffected.
    var ensureShopifyChromeStyle = function () {
        var styleId = "st-hide-shopify-chrome-style";
        if (document.getElementById(styleId))
            return;
        var style = document.createElement("style");
        style.id = styleId;
        style.textContent = "\n\t\t\thtml.st-hide-shopify-chrome > body > header,\n\t\t\thtml.st-hide-shopify-chrome > body > footer,\n\t\t\thtml.st-hide-shopify-chrome .shopify-section-group-header-group,\n\t\t\thtml.st-hide-shopify-chrome .shopify-section-group-footer-group,\n\t\t\thtml.st-hide-shopify-chrome .shopify-section-header,\n\t\t\thtml.st-hide-shopify-chrome .shopify-section-footer,\n\t\t\thtml.st-hide-shopify-chrome #shopify-section-header,\n\t\t\thtml.st-hide-shopify-chrome #shopify-section-footer,\n\t\t\thtml.st-hide-shopify-chrome .announcement-bar-section,\n\t\t\thtml.st-hide-shopify-chrome .announcement-bar,\n\t\t\thtml.st-hide-shopify-chrome [id*=\"announcement\" i],\n\t\t\thtml.st-hide-shopify-chrome [class*=\"announcement\" i],\n\t\t\thtml.st-hide-shopify-chrome [id*=\"shopify-section-header\" i],\n\t\t\thtml.st-hide-shopify-chrome [id*=\"shopify-section-footer\" i],\n\t\t\thtml.st-hide-shopify-chrome .header-wrapper,\n\t\t\thtml.st-hide-shopify-chrome .footer {\n\t\t\t\tdisplay: none !important;\n\t\t\t}\n\t\t";
        document.head.appendChild(style);
    };
    var toggleShopifyChrome = function (hide) {
        ensureShopifyChromeStyle();
        document.getElementsByTagName("html")[0].classList.toggle("st-hide-shopify-chrome", hide);
    };
    return (_jsx(I18nextProvider, __assign({ i18n: i18n }, { children: _jsx(ThemeProvider, __assign({ theme: overrideDefaultTheme }, { children: _jsxs("div", __assign({ style: isLoader ? { pointerEvents: "none", overflow: "hidden", position: "relative" } : { pointerEvents: "all" } }, { children: [isLoader ? _jsx(CircularProgress, { sx: isLoadingCSS }) : "", _jsxs("div", __assign({ style: { position: "relative" } }, { children: [_jsx(Snackbar, __assign({ autoHideDuration: TOASTER_TIMEOUT, anchorOrigin: { vertical: "bottom", horizontal: "right" }, open: isSnackbar }, { children: _jsx(Alert, __assign({ severity: "error", onClose: function () {
                                        isAPIServerError.next(false);
                                    } }, { children: "Error while processing your request...!!!" })) })), parsedAuthentication && parsedAuthentication.token !== "" ? _jsx(HomeLayout, {}) : _jsx(LoginComponent, {})] }))] })) })) })));
}
